import { render } from "./ContentWrapper.vue?vue&type=template&id=51399f98&scoped=true"
import script from "./ContentWrapper.vue?vue&type=script&lang=js"
export * from "./ContentWrapper.vue?vue&type=script&lang=js"

import "./ContentWrapper.vue?vue&type=style&index=0&id=51399f98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51399f98"

export default script